const AUTO_TIMER_SESSION_KEY = "ems_auto_timer_session_started_at";

export function getAutoTimerSessionStartedAt() {
  if (typeof window === "undefined") {
    return null;
  }

  const rawValue = window.localStorage.getItem(AUTO_TIMER_SESSION_KEY);
  const parsedValue = Number(rawValue);

  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
}

export function ensureAutoTimerSessionStartedAt() {
  const existingValue = getAutoTimerSessionStartedAt();
  if (existingValue) {
    return existingValue;
  }

  const newValue = Date.now();
  setAutoTimerSessionStartedAt(newValue);
  return newValue;
}

export function setAutoTimerSessionStartedAt(value) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(AUTO_TIMER_SESSION_KEY, String(value));
}

export function clearAutoTimerSessionStartedAt() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTO_TIMER_SESSION_KEY);
}

export {
  AUTO_TIMER_SESSION_KEY,
};
